import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import useReactRouter from 'use-react-router';
import MaterialTable from 'material-table';
import { createMuiTheme, ThemeProvider, makeStyles } from "@material-ui/core/styles";
import { Button, Chip, Snackbar } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import GetAppIcon from '@material-ui/icons/GetApp';
import MuiAlert from '@material-ui/lab/Alert';
import axios from '../../Helpers/Axiosbase';
import * as actions from '../../Store/Actions'
import { saveAs } from 'file-saver';
var fileDownload = require('react-file-download');
var JSZip = require('jszip')
var zip = new JSZip();

const useTheme = createMuiTheme({
  root: {
    overflowY: 'scroll',
  },
  overrides: {
    MuiTableCell: {
      root: {
        padding: 0
      },
    },
    MuiTypography: {
      h6: {
        fontSize: '18px'
      }
    }
  }
});

const useStyles = makeStyles(theme => ({
  btn: {
    fontSize: '0.600rem'
  },
  chipbtn: {
    fontSize: '0.600rem'

  }

}))

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Configuration() {
  const classes = useStyles();
  const { history } = useReactRouter();
  let showLoader = true;
  let allconfig = [];

  const reduxAuth = useSelector((state) => state.auth)
  const appcomponent = useSelector((state) => state.appcomponent)
  const dispatch = useDispatch();

  // const [checked, setChecked] = React.useState(0);
  // const handleChange = (Index, rowData) => {
  //   console.log(Index, rowData);
  //   setChecked(Index);
  // };
  const [schema, setSchema] = React.useState({
    config: {
      metaInfo: {
        "dataIndex": "config",
        "collectionName": "configObjects",
        "responseObjectName": "response"
      },
      configObjects: [
      ]
    }
  })

  const [loader, setLoader] = React.useState(false);
  const [opendelalert, setopendelalert] = React.useState({
    open: false,
    msg: '',
    delbox: ''
  });
  const [openalert, setOpenAlert] = React.useState({
    open: false,
    btn: '',
    msg: '',
    err: ''
  });
  const [columns] = React.useState([
    {
      title: 'Status', field: 'isPublished', render: rowData => {
        if (rowData.isPublished === false) {
          return <Chip size="small" label="UNPUBLISHED" color="secondary" className={classes.chipbtn} />
        }
        else {
          return <Chip size="small" label="PUBLISHED" color="primary" className={classes.chipbtn} />
        }
      }, editable: 'never'
    },

    { title: 'Domain', field: 'domain', editable: 'never' },
    { title: 'Relationship', field: 'relationship', editable: 'never' },
    { title: 'EntityType', field: 'entityType', editable: 'never' },
    { title: 'Role', field: 'role', editable: 'never' },

    // {
    //   title: 'User', field: 'user'
    // },

    {
      title: 'Actions', field: 'isPublished', render: rowData => {
        if (rowData.isPublished === false) {
          return <Button disabled={reduxAuth.defaultEnvironment.includes("ds") || reduxAuth.defaultEnvironment.includes("demo") || reduxAuth.defaultEnvironment.includes("presales") || reduxAuth.defaultEnvironment.includes("ascend") || reduxAuth.defaultEnvironment.includes("sepik01")  || reduxAuth.defaultEnvironment.includes("px360")  || reduxAuth.defaultEnvironment.includes("cx360")? false : true} variant="contained" title="Publish" color="primary" className={classes.btn} onClick={(event) => publishClickHandler(event, rowData)}>Publish</Button>
        }
        else {
          return <Button disabled={reduxAuth.defaultEnvironment.includes("ds") || reduxAuth.defaultEnvironment.includes("demo") || reduxAuth.defaultEnvironment.includes("presales") || reduxAuth.defaultEnvironment.includes("ascend") || reduxAuth.defaultEnvironment.includes("sepik01")  || reduxAuth.defaultEnvironment.includes("px360")  || reduxAuth.defaultEnvironment.includes("cx360")? false : true} variant="contained" title="UnPublish" color="primary" className={classes.btn} onClick={(event) => unpublishClickHandler(event, rowData)}>UnPublish</Button>
        }
      }
    },

  ]);

  const deleteConfigHandler = (event, rowData) => {
    let cntpublish = 0;
    let delconfig = appcomponent.selectedConfigurationForBulkCopy;
    // console.log("Delete Config:"+JSON.stringify(delconfig));
    delconfig.map(data => {
      if (data.isPublished === true) {
        cntpublish += cntpublish + 1
      }
    })
    if (cntpublish > 0) {
      setopendelalert({
        open: true,
        msg: "You can only delete configurations are Unpublished Status. Please select Unpublished configurations only."
      })
    }
    else {
      setopendelalert({
        open: true,
        msg: "Are you sure you want to delete the configurations?",
        delbox: "true"
      })
    }
    // console.log("Delete Config:" + cntpublish);
  }

  const handleDownLoadClick = () => {
    let sc = appcomponent.selectedConfigurationForBulkCopy;
    let listconfig = sc.map((scc) => {
      let jsondoc = scc.jsonDocument;
      schema.config.configObjects[0] = scc.jsonDocument;
      zip.file(scc.jsonDocument.name + ".json", JSON.stringify(schema.config))
    });
    zip.generateAsync({ type: "blob" })
      .then(function (content) {
        // see FileSaver.js
        saveAs(content, appcomponent.selectedComponent.componentContextCode + ".zip");
      });
    let remove = sc.map((scc) => {
      zip.remove(scc.jsonDocument.name + ".json");
    });

  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert({
      open: false,
      btn: ''
    });
  };

  const handledelalertclose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setopendelalert({
      open: false,
      msg: ''
    });
  };

  const handleNoAction = () => {
    setopendelalert({
      open: false,
      msg: '',
      delbox: ''
    })
    dispatch(actions.configuration());
    dispatch(actions.selectedConfigurationForBulkCopy([]))
    history.push("/Config")
  }

  const handleYesAction = () => {

    let url = "configurationDelete"
    let postdata = { token: reduxAuth.token, userId: reduxAuth.userId, environmentId: appcomponent.selectedEnvironment.tenantId, configList: appcomponent.selectedConfigurationForBulkCopy }
    axios.post(url, postdata)
      .then(response => {
        console.log("response", response)
        dispatch(actions.configuration());
        history.push("/Config")
      })
      .catch(err => {
        console.log("err", err);
        if (typeof err.response != "object") {
          setOpenAlert({
            open: true,
            btn: 'Delete',
            msg: 'Network Error:Please Check Your Internet Connection',
            err: 'error'
          });
        }
        else {
          if (err.response.status === 403) {
            dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
          }
        }
      });
    setopendelalert({
      open: false,
      msg: '',
      delbox: ''
    })
    dispatch(actions.configuration());
    dispatch(actions.selectedConfigurationForBulkCopy([]))
    history.push("/Config")
  }

  var publishClickHandler = (event, configData) => {
    event.stopPropagation();
    setLoader(true);
    let url = "publishConfiguration"
    let postdata = {
      _id: configData._id,
      jsonDocument: configData.jsonDocument,
      isPublished: true,
      componentContextCode: configData.componentContextCode,
      domain: configData.domain,
      entityType: configData.entityType,
      context1: configData.context1,
      context2: configData.context2,
      context3: configData.context3,
      relationship: configData.relationship,
      role: configData.role,
      app: configData.app,
      isDuplicate: configData.isDuplicate,
      environmentId: configData.environmentId,
      token: reduxAuth.token,
      userId: reduxAuth.userId
    };
    axios.post(url, postdata, { headers: { strictSSL: false } })
      .then(response => {
        setOpenAlert({
          open: true,
          btn: 'publish',
          msg: 'Successfully Published'
        });
        setLoader(false);
        dispatch(actions.configuration());
      })
      .catch(err => {
        setLoader(false);
        if (typeof err.response != "object") {
          setOpenAlert({
            open: true,
            btn: 'publish',
            msg: 'Network Error:Please Check Your Internet Connection',
            err: 'error'
          });
        }
        else {
          if (err.response.status === 403) {
            dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
          }
        }
      });
  }

  var unpublishClickHandler = (event, configData) => {
    event.stopPropagation();
    setLoader(true);
    let url = "unpublishConfiguration"
    let postdata = {
      _id: configData._id,
      jsonDocument: configData.jsonDocument,
      isPublished: false,
      componentContextCode: configData.componentContextCode,
      domain: configData.domain,
      entityType: configData.entityType,
      context1: configData.context1,
      context2: configData.context2,
      context3: configData.context3,
      relationship: configData.relationship,
      role: configData.role,
      app: configData.app,
      isDuplicate: configData.isDuplicate,
      environmentId: configData.environmentId,
      token: reduxAuth.token,
      userId: reduxAuth.userId
    };
    axios.post(url, postdata)
      .then(response => {
        setOpenAlert({
          open: true,
          btn: 'unpublish',
          msg: 'Successfully UnPublished'
        });
        setLoader(false);
        dispatch(actions.configuration());
      })
      .catch(err => {
        setLoader(false);
        if (typeof err.response != "object") {
          setOpenAlert({
            open: true,
            btn: 'unpublish',
            msg: 'Network Error:Please Check Your Internet Connection',
            err: 'error'
          });
        }
        else {
          if (err.response.status === 403) {
            dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
          }
        }
      });
  }

  const handledata = (event, rowData) => {
    history.push('/ManageConfig', rowData);
  }

  if (appcomponent.allComponent != null && appcomponent.selectedApp != null && appcomponent.selectedEnvironment != null && appcomponent.selectedConfiguration != null) {
    allconfig = appcomponent.selectedConfiguration.filter((data) => {
      return data.domain === appcomponent.selectedApp.domain || data.domain === '_DEFAULT'
    })
    showLoader = false;
    // setLoader(false);
  }

  return (
    <ThemeProvider theme={useTheme}>
      {showLoader === true ? <LinearProgress /> : null}
      {openalert.open ?
        <Snackbar
          open={openalert.open} autoHideDuration={3000}
          onClose={handleClose}>
          <Alert
            severity={openalert.err === 'error' ? "warning" : "success"}
            color={openalert.err === 'error' ? "warning" : "info"}
            variant="outlined">
            {openalert.msg}
          </Alert>
        </Snackbar>
        : null}

      {opendelalert.open && opendelalert.delbox != 'true' ?
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={opendelalert.open} autoHideDuration={3000}
          onClose={handledelalertclose}>
          <Alert
            severity="warning"
            // color={"warning"}
            variant="filled">
            {opendelalert.msg}
          </Alert>
        </Snackbar>
        : null}

      {opendelalert.open && opendelalert.delbox == 'true' ?
        <Alert
          action={
            <div>
              <Button color="inherit" size="small" onClick={() => handleNoAction()}>
                No
              </Button>
              <Button color="inherit" size="small" onClick={() => handleYesAction()}>
                Yes
              </Button>
            </div>}
          severity="warning"
          // color={"warning"}
          variant="filled">
          {opendelalert.msg}
        </Alert>
        : null}

      <MaterialTable
        disabled={appcomponent.selectedEnvironment != null && appcomponent.selectedEnvironment.isSync.toString() === "0"}
        title={appcomponent.selectedApp != null && appcomponent.selectedComponent != null ? appcomponent.selectedApp.displayName + ">>" + appcomponent.selectedComponent.displayName : "Configuration"}
        options={
          {
            pageSize: 15,
            pageSizeOptions: [15, 20, 50, 100],
            // actionsColumnIndex: -1,
            selection: true,
            padding: 'dense'
          }
        }
        columns={columns}
        data={allconfig}
        isLoading={loader}
        onRowClick={(event, rowData) => handledata(event, rowData)}
        actions={[
          {
            icon: 'save_alt',
            tooltip: 'save_alt',
            onClick: (event, rowData) => {
              handleDownLoadClick();
            }
          },
          {
            // selection:false,
            icon: 'delete',
            tooltip: 'Delete',
            onClick: (event, rowData) => {
              deleteConfigHandler();
            }
          },
          {
            icon: 'add',
            tooltip: 'Add Configuration',
            isFreeAction: true,
            onClick: (event) => history.push("/AddConfiguration")
          },
          {
            icon: 'refresh',
            tooltip: 'Refresh',
            isFreeAction: true,
            onClick: () => {
              dispatch(actions.configuration())
            }
          },
        ]}
        onSelectionChange={(rows) => dispatch(actions.selectedConfigurationForBulkCopy(rows))}
      />
    </ThemeProvider>
  );
}
